import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { ClientContainer } from 'modules/hub/components/ClientContainer';
export const renderEndpoint = async () => {
    const element = document.getElementById(`widget`);
    const preloadedState = window.__PRELOADED_STATE__?.widget?.props;
    if (element) {
        hydrateRoot(element, React.createElement(ClientContainer, { ...preloadedState }));
    }
};
renderEndpoint();
